import React, { useState, useEffect } from 'react';
import { Form, Input, Select } from 'antd';



const { Option } = Select;
const { TextArea } = Input;

export default function ZayavlenieNaChlenstvoVFederatsii(props) {
    const { auth } = props;

    const [regionalnieOtdeleniya, setRegionalnieOtdeleniya] = useState([]);

    useEffect(() => {
        // Запрос списка региональных отделений
        // object: "RegionalnieOtdeleniya", property: "ID"
        auth.fetch('/api/query/RegionalnieOtdeleniya?s-nazvanie').then(res => {
            if (res && res.data) {
                setRegionalnieOtdeleniya(res.data);
            }
        });
    }, []);

    const options = regionalnieOtdeleniya.map(i => (
        <Option key={i.ID} value={i.ID}>{i.nazvanie}</Option>
    ));
    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
        >
            <Form.Item
                name={"regionalnoeOtdelenieID"}
                label={"Региональное отделение"}
                rules={[{ required: true, message: 'Укажите региональное отделение!' }]}
            >
                <Select>
                    {options}
                </Select>
            </Form.Item>
            <Form.Item
                name={"opisanieZhelaniyaStatChlenomFederatsii"}
                label={"Описание желания стать членом федерации"}
                rules={[{ required: true, message: 'Введите описание желания стать членом федерации!' }]}
            >
                <TextArea rows={4} />
            </Form.Item>
            {/* <Form.Item
            key={p.uuid}
            name={uncapitalize(p.name)}
            label={p.label}
            rules={[{ required: true, message: 'Введите описание желания стать членом федерации!' }]}
        >
            {p.type === "string" && <TextArea rows={4} />}
            {p.type === "string" && <Input />}
            {p.type === "uint" && <InputNumber style={{ width: "50%" }} />}
            {p.type === "date" && <DatePicker locale={locale} />}
            {p.type === "object" && <Select>
                <Option value="jack">Jack</Option>
                <Option value="lucy">Lucy</Option>
                <Option value="Yiminghe">yiminghe</Option>
            </Select>}
        </Form.Item> */}
        </Form>
    );
}
